import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
    .use(initReactI18next)
    .use(Backend)
    .use(LanguageDetector)
    .init({
      fallbackLng: 'en',
      lng: localStorage.getItem("language") || 'en',
      supportedLngs: ['en', 'cz'],
      interpolation: {
        escapeValue: false,
      },
      backend: {
        loadPath: '/locales/{{lng}}/translate.json',
      },
    });

export default i18n;
